import { Component, OnInit } from '@angular/core';
import { UntypedFormArray, UntypedFormControl, UntypedFormGroup } from '@angular/forms';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';
import * as BUTTON_CONFIG from '../../../../../constants/button/index';
import { TimesheetType } from '../../../../../constants/lookup/timesheet/timesheet-type.enum';
import { API_METHOD_CONSTANTS } from '../../../../../constants/ngrx-store/core';
import { TIMESHEET_METHOD_CONSTANT } from '../../../../../constants/ngrx-store/timesheet';
import { CommonUtil } from '../../../../../core/utils/common-util';
import { TimesheetStoreService } from '../../../../../state/modules/timesheet/timesheet-store.service';
import { TaskGroupStatus } from '../task-group-list-action/task-group-list-action.constant';
import { AddTaskGroupListActionControls } from './add-shift-task-group-constant';

@Component({
  standalone: false,
  selector: 'kt-add-shift-task-group',
  templateUrl: './add-shift-task-group.component.html',
  styleUrls: ['./add-shift-task-group.component.scss'],
})
export class AddShiftTaskGroupComponent implements OnInit {
  buttonConfig = BUTTON_CONFIG;
  constructor(public activeModal: NgbActiveModal, private timeSheetStoreService: TimesheetStoreService) { }
  newTaskFormGroup = new UntypedFormGroup({ subTasks: new UntypedFormArray([new UntypedFormGroup({})]) });
  addTaskGroupControl = AddTaskGroupListActionControls;
  shiftTimesheetInfo = null;
  timesheet = null;
  isUncsheduled = null;
  taskGroupListDetail = null;
  location = { latitude: CommonUtil.Latitude, logitude: CommonUtil.Longitude };
  user_id = 0;

  get subTasks() {
    return this.newTaskFormGroup.get('subTasks') as UntypedFormArray;
  }


  addClickHandler() {
    this.subTasks.push(new UntypedFormGroup({}));
  }

  removeTaskGroup(index) {
    this.subTasks.removeAt(index);
  }
  ngOnInit() {
    if (navigator.geolocation && navigator.geolocation.getCurrentPosition) {
      // navigator.permissions.query({ name: 'geolocation' }).then((result) => {
      // if (result.state === 'granted') {
      navigator.geolocation.getCurrentPosition((position) => {
        this.location.latitude = position.coords.latitude;
        this.location.logitude = position.coords.longitude;
      });
      // }
      // });
    }
  }

  taskgroupFilled(data) {
    if (data.success) {
      this.activeModal.close({ reload: true });
    }

  }

  saveButtonClickHandler() {
    if (this.newTaskFormGroup.invalid) {
      setTimeout(() => {
        this.newTaskFormGroup.markAllAsTouched();
      });
      // console.log(this.newTaskFormGroup.value);
      return;
    }
    const formValue = this.newTaskFormGroup.value;

    const paylodForSelectedTasks = formValue.subTasks.map(task => {
      return {
        timesheet_task_group_child_fk_task_group_id: 0,
        timesheet_task_group_child_fk_task_group_child_id: 0,
        timesheet_task_group_child_fk_task_group_child_name: task.sub_task_name,
        timesheet_task_group_child_status: TaskGroupStatus.Done,
      };
    });
    const payload = {
      action_type: 'Add',
      client_id: this.shiftTimesheetInfo.client.client_id,
      location_id: this.shiftTimesheetInfo.location.location_id,
      area_id: this.shiftTimesheetInfo.area.area_id,
      timezone_id: 1,
      user_id: this.user_id,
      is_unscheduled: this.isUncsheduled,
      timesheet_id: this.timesheet.timesheet_id,
      task_group_id: 0,
      shift_task_group_id: 0,
      location_task_group_id: 0,
      type: TimesheetType.SHIFT,
      timesheet_log: {
        timesheet_log_name: formValue.task_group_name,
        timesheet_log_config: {},
        timesheet_log_is_paid: false,
      },
      timesheet_transaction: {
        timesheet_transaction_config: {},
        timesheet_transaction_device_config: CommonUtil.getShiftMetaData(),
        timesheet_transaction_device: 'Web',
        timesheet_transaction_app_version: '',
        timesheet_transaction_scan_type: '',
        timesheet_transaction_scan_image_url: '',
        timesheet_transaction_notes: '',
        timesheet_transaction_latitude: this.location.latitude.toString(),
        timesheet_transaction_longitude: this.location.logitude.toString(),
        timesheet_transaction_accuracy: 0,
      },
      timesheet_task_group: {
        timesheet_task_group_fk_task_group_id: 0,
        timesheet_task_group_fk_task_group_name: formValue.task_group_name,
        timesheet_task_group_comments: '',
        timesheet_task_group_childs: paylodForSelectedTasks,
      },
    };
    this.dispatchTaskGroup(payload);
  }

  dispatchTaskGroup(data) {
    this.timeSheetStoreService.dispatchTimesheetCommon({
      module: TIMESHEET_METHOD_CONSTANT.TASK_GROUP,
      method: API_METHOD_CONSTANTS.INSERT,
      data,
      callback: this.taskgroupFilled.bind(this),
    });
  }

}
